export const defaultCurrencyCode = 'EUR';

export const getCurrencySymbol = (intl, currency) => intl.formatNumber(0, { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: 0 }).replace(/\d/g, '').trim()